import { NumberWithUnit } from "@foodpilot/foods";
import { Box, useTheme } from "@mui/material";

type TransportDistanceTagProps = {
    value: number | null;
    label: string;
    emptyLabel: string;
};

/** Read-only distance output matching the Figma `Score tag` primitive. */
export const TransportDistanceTag = ({ value, label, emptyLabel }: TransportDistanceTagProps) => {
    const theme = useTheme();

    return (
        <Box
            component="output"
            aria-label={value === null ? emptyLabel : `${label} ${value} km`}
            data-testid="transport-distance-tag"
            sx={{
                alignItems: "center",
                alignSelf: "end",
                backgroundColor: theme.custom.grey[300],
                borderColor: theme.custom.strokes.containerDivider.color,
                borderRadius: theme.spacing(0.5),
                boxSizing: "border-box",
                display: "flex",
                height: theme.spacing(5),
                paddingX: theme.spacing(1),
                position: "relative",
                width: "max-content",
            }}
        >
            <NumberWithUnit value={value} unit="km" size="micro" unitVariant="small-regular" emptyLabel={emptyLabel} />
            <Box
                aria-hidden
                sx={{
                    borderColor: "inherit",
                    borderRadius: "inherit",
                    borderStyle: theme.custom.strokes.containerDivider.style,
                    borderWidth: theme.custom.strokes.containerDivider.width,
                    inset: 0,
                    pointerEvents: "none",
                    position: "absolute",
                }}
            />
        </Box>
    );
};

export default TransportDistanceTag;
